<template>
  <MineCraftDescription />
  <div class="craft-input">
      <template v-if="current!=null">
        <template v-for="(k, index) in getCraft(current)" :key="k">
          <template v-if="index==page_craft">

            <template v-if="getCraftItems(k).length == 9">
              <div class="sections craft-table">
                <template v-for="(s, idx) in getCraftItems(k)" :key="s">
                  <div :id="'s'+parseInt(idx + 1)" :set="item = getItem(s)">
                    <i v-if="item!=undefined" @click="selectItem" :title="getTitle(item)" class="item" :id="s" :style="getStyle(item)"></i>
                  </div>
                </template> 
              </div>
            </template>

            <template v-if="getCraftItems(k).length == 3">
              <div class="sections brew">
                <div class="bubbles"></div>
                <template v-for="(s, idx) in getCraftItems(k)" :key="s">
                  <div :id="'b'+parseInt(idx + 1)" :set="item = getItem(s)">
                    <i v-if="item!=undefined" @click="selectItem" :title="getTitle(item)" class="item" :id="s" :style="getStyle(item)"></i>
                  </div>
                </template>
              </div>
            </template> 

            <template v-if="getCraftItems(k).length == 2 && getType(k) == 0">
              <div class="sections fire">
                <template v-for="(s, idx) in getCraftItems(k)" :key="s">
                  <div :id="'p'+parseInt(idx + 1)" :set="item = getItem(s)">
                    <i v-if="item!=undefined" @click="selectItem" :title="getTitle(item)" class="item" :id="s" :style="getStyle(item)"></i>
                  </div>
                </template>
              </div>
            </template> 


            <template v-if="getCraftItems(k).length == 1">
              <div class="sections kamn">
                <span id="cuz-title">Камнерез</span>
                <template v-for="(s, idx) in getCraftItems(k)" :key="s">
                  <div :id="'d'+parseInt(idx + 1)" :set="item = getItem(s)">
                    <i v-if="item!=undefined" @click="selectItem" :title="getTitle(item)" class="item" :id="s" :style="getStyle(item)"></i>
                  </div>
                </template>
              </div>
            </template> 

            <template v-if="getCraftItems(k).length == 2 && getType(k) == 1">
              <div class="sections cuzn">
                <span id="cuz-title">Стол кузнеца</span>
                <template v-for="(s, idx) in getCraftItems(k)" :key="s">
                  <div :id="'c'+parseInt(idx + 1)" :set="item = getItem(s)">
                    <i v-if="item!=undefined" @click="selectItem" :title="getTitle(item)" class="item" :id="s" :style="getStyle(item)"></i>
                  </div>
                </template>
              </div>
            </template> 

        </template> 
        </template> 
      </template> 
      <template v-else>
        <div class="sections craft-table">
          <template v-for="idx in 9" :key="idx">
              <div :id="'s'+parseInt(idx + 1)">
              </div>
          </template> 
        </div>     
      </template>
    
    <div class="point-craft">→</div> 
    <div class="res-craft">
      <i v-if="current!=null" :title="getTitle(current)" class="item" :style="getStyle(current)"></i>
      <b v-if="current!=null" :set="count = getCount(current)"><template v-if="count>0">{{count}}</template></b>
    </div>
    <div class="navigator" :set="len = getCraft(current).length" v-show="len > 1">
      <div class="craft-prev">
        <a href="" v-if="page_craft > 0" @click="page_craft--" @click.prevent="openThread">&laquo; Назад</a>
        <span v-else>&laquo; Назад</span>
      </div>
      <div class="craft-next">
        <a href="" v-if="len - 1 > page_craft" @click="page_craft++" @click.prevent="openThread">Вперёд &raquo;</a>
        <span v-else>Вперёд &raquo;</span>
      </div>
      {{page_craft+1}}/{{len}}
    </div>
  </div>
  <MineCraftSearch />
  <div class="craft-list">
    <template v-for="(k, value, index) in craft_list" :key="index">
      <i v-if="k.show==undefined||k.show==1" @click="selectItem" :title="getTitle(k)" class="item" :id="value" :style="getStyle(k)" :class="{ 'no-craft': isCrafted(k) }"></i>
      {{ checkHash(k) }}
    </template>
  </div> 
</template>

<script>
import MineCraftDescription from './craftdescr.vue'
import MineCraftSearch  from './craftsearch.vue'

export default {
  name: 'MineCraft',
  components: {
    MineCraftDescription,
    MineCraftSearch,
  },
  data() {
    return {
      craft_list: [],
      current: null,
      page_craft: 0,
      current_items: [],
      current_type: 0
  }},
  mounted() {
    this.$nextTick(function () {
      fetch('../craft.json', {
              headers: { 'Content-type': 'application/json' },
          }).then(res=>res.json()).then((response) => {
              this.craft_list = this.renderData(response);
          });
    })
},
methods: {
    renderData(data){
      Object.entries(data).forEach(entry => {
        const [key] = entry;
        var s = key.split('x');
        var y = - parseInt(s[0].slice(1)) * 32;
        var x = -(parseInt(s[1]) * 32);
        data[key]["x"] = x;
        data[key]["y"] = y;
      });
      return data
    },
    getTitle(k){
      if (k == undefined || k == null)
        return ""
      return Object.keys(k)[0]
    },
    getStyle(value){
      if (value == undefined) return ''
      return `background-position: ${value.x}px ${value.y}px;`
    },
    isCrafted(k){
      let value = k[Object.keys(k)[0]];
      return !value.length || value[0]['l'] == ''
    },
    getCraft(k){
      if (k == null) return []
      return k[Object.keys(k)[0]]
    },
    selectItem(event){
      let s = this.craft_list[event.currentTarget.id];
      if (this.getCraft(s)[0]['l']!= ''){
        this.current = s;
        location.hash = "#" + encodeURI(this.getTitle(this.current));
      }
      this.page_craft = 0;
    },
    getCraftItems(k){
      var s = k['l'].split(',');
      this.current_items = s;
      this.current_type = 0;
      if (k['t'] != undefined)
        this.current_type = this.getType(k);
      return s;
    },
    getType(k){
      if (k['t'] == undefined)
        return 0
      return k['t'];
    },
    getItem(k){
      return this.craft_list[k];
    },
    getCount(k){
      if (k != null)
        return parseInt(this.getCraft(k)[0]['r'])
      return 0
    },
    checkHash(k){
      if(this.current == null && location.hash !='' && decodeURI(location.hash) == "#" + this.getTitle(k))
      {
        this.current = k;
        this.page_craft = 0;
      }
    },
    search(v){
      v = v.toLowerCase().trim();
      for (const [key, entry] of Object.entries(this.craft_list)) {
        var s = Object.keys(entry)[0];
        if(s.toLowerCase().indexOf(v) != -1){
          this.craft_list[key].show=1;
        }else{
          this.craft_list[key].show=0;
        }
      }
    }
  }
}
</script>


<style>
h2 {
  font-size: 20px;
}
.lists {
    margin-left: 10px;
    margin-bottom: 0px;
}
.craft-list{
position: relative;
    overflow-y: overlay;
    max-height: 300px;
    height: 300px;
    max-width: 740px;
    width: 740px;
    background-color: white;
    border: 1px solid #dfe0e2;
    padding: 10px;
}

.craft-list i, .sections div i, .res-craft i{
    position: relative;
    padding-top: 32px; 
    cursor: pointer;   
}

#p2:after{
    top: 0;
    left: 0;
    content: " ";
    background: url(@/assets/fire.png);
    width: 32px;
    height: 32px;
    float: left;
    background-position: 0px 0px;
    position: absolute;
    top: -45px;
}
div#p2 {
    position: absolute;
    bottom: 5px;
}
div#c1, div#c2 {
    display: inline-block;
    margin-top: 52px;
}
.craft-list i:hover:before, .sections div i:hover:before, .res-craft i:hover:before {
    background-color: #d44b38;
}
.craft-input{
    background-color: #c6c6c6;
    width: 265px;
    height: 150px;
    border: 4px groove #e2e2e2;
    margin-bottom: 60px;
    padding: 3px;
    position: relative;
    margin-top: 35px;
}
.res-craft {
    position: absolute;
    width: 38px;
    height: 38px;
    background-color: #6f6a6a;
    right: 5px;
    top: 38%;
    border: 2px groove #948e8e;
}
.point-craft {
    position: absolute;
    width: 45px;
    height: 43px;
    top: 35%;
    right: 55px;
    font-size: 30px;
    color: #6f6a6a;
}
.res-craft b {
  color: white;
    position: absolute;
    bottom: -8px;
    right: 0px;
    font-size: 18px;
    width: min-content;
    text-align: right;
    top: 18px;
    height: min-content;
}
.sections{
    height: 148.5px;
    width: 150px;
    background-color: #c6c6c6;
    display: flex;
    flex-direction: row;
    flex-flow: wrap;
}
.sections div {
    width: 37px;
    height: 37px;
    background-color: #6f6a6a;
    margin: 4px;
    border: 2px groove #948e8e;
}
.fire div {
    margin-left: 50px;
}

.craft-list .no-craft {
    display: none;
}
.craft-list i:before{
    margin:3px;
}
#csearch{
    width: 278px;
    height: 30px;
    margin-bottom: 5px;
}
.share-buttons {
    top: -30px;
}
.navigator {
    display: flex;
    justify-content: space-between;
    padding: 15px;
}

.sections.brew {
    background: url(@/assets/brew.png) no-repeat 32px 5px;
    position: relative;
}
div#b2 {
    margin-left: 120px;
    margin-top: -25px;
}
div#b3 {
    margin-top: 28px;
    margin-left: 120px;
}

.bubbles {
    background: url(@/assets/bubbles.gif) no-repeat;
}

.bubbles {
    position: absolute;
    left: 87px;
    border: initial !important;
    background-color: initial !important;
    height: 100px !important;
}

span#plus {
    margin-left: 10px;
    margin-right: 10px;
    font-size: 30px;
    text-align: center;
    position: absolute;
    top: 50px;
    color: #6f6a6a;
}
div#c2 {
    margin-left: 39px;
}
span#cuz-title {
    position: absolute;
}
div#d1 {
    position: absolute;
    top: 55px;
    left: 87px;
}
</style>
